import React from 'react';
import Integrations from '../components/integrations/Integrations';

const IntegrationsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Integrations />
    </div>
  );
};

export default IntegrationsPage;
